import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Spinner,
  Pagination,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import moment from "moment";
import { BsPlus, BsX, BsSend, BsPrinter } from "react-icons/bs";
import {
  FaTrash,
  FaCloudDownloadAlt,
  FaCloudUploadAlt,
  FaListAlt,
  FaFileAlt,
} from "react-icons/fa";
import AdminScreenHeader from "../admin/adminScreenHeader";
import "../../css/client/form24Q.css";
import { apiPost } from "../../service/admin/apiService";
import Loader from "../loader";
import { showError, showSuccess } from "../../utils/toast";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import {
  form24QFields,
  getPreviousMonthAndFY,
  isDataSentToCA,
  isDataReviewByCA,
  formatFinancialYears,
} from "../../utils/client/misc";
import Form24QTable from "./form24QTable";
import ExportToExceljs from "../../utils/exportToExcel";
import ExportToExcelDeductee24Q from "../../utils/exportToExcelDeductee24Q";
import DateFilters from "./dateFilters";
import ChallanDetail from "./challanDetail";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const Form24Q = () => {
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [formfinancialYear, setFormFinancialYear] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedFYearId, setSelectedFYearId] = useState(0);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [form24QInfo, setForm24QInfo] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copyDataloading, setCopyDataLoading] = useState(false);
  const [submitToCALoading, setsubmitToCALoading] = useState(false);
  const [isDataSendToCA, setIsDataSendToCA] = useState(false);
  const [isDataReviewedByCA, setIsDataReviewedByCA] = useState(false);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [showChallanInfo, setShowChallanInfo] = useState(false);
  const [challanAmount, setChallanAmount] = useState(0);
  const [uploadingEmpLoading, setUploadingEmpLoading] = useState(false);
  const [downloadingEmpLoading, setDownloadingEmpLoading] = useState(false);
  const [empIds, setEmpIds] = useState([]);
  const [showDeducteeModal, setShowDeducteeModal] = useState(false);
  const [searchEmployee, setSearchEmployee] = useState("");
  const [employee, setEmployee] = useState([]);
  const [deducteeEmpPan, setDeducteeEmpPan] = useState([]);
  const [form24QDeducteeData, setForm24QDeducteeData] = useState([]);
  const [report24QDeducteeData, setReport24QDeducteeData] = useState([]);
  const [modelType, setModelType] = useState("DeducteeDetails");

  const navigate = useNavigate();

  let grossTotalValue = 0;
  let totalDeductionValue = 0;
  let netAmountValue;
  let totalOtherIncomeValue = 0;
  let totalOtherAllowanceValue = 0;
  let totalBasicValue = 0;
  let netpaySalary = 0;
  let totalDeduction80CValue = 0;
  let totalGpfValue = 0;
  let totalGisValue = 0;
  let totalEmpContValue = 0;
  let totalOtherDeductionValue = 0;

  const marchOnlyFields = [
    // "ca",
    // "gp",
    "aa1",
    "aa2",
    "toa",
    // "toi",
    "an1",
    "an2",
    "lic",
    "ppf",
    "tf",
    "hp",
    "ti",
    "80c",
    "80d",
    "80u",
    "80g",
    "g50",
    "g100",
    "80b",
    "ccd",
    "ad1",
    "ad2",
    "pi",
    "nt",
    // "ed",
    // "eg",
    "rp",
    "ad3",
    "ad4",
    "ad5",
    "sd",
    "svd",
    "80ds",
    "80df",
    "80dd",
    "80ddb",
    "80e",
    "80tta",
    "80ttb",
    "nps",
    "gt",
    "emc",
    "mr",
    "trp",
    "si",
    "fdi",
    "fpi",
    "80cch2",
    "fdr",
    "nsci",
    "pfi",
    "gpfTotal",
    "gisTotal",
    "empContTotal",
    "totalDeduction",
    "cch",
    "totalOtherDeduc",
  ];

  const tooltipLabels = {
    sd: "Standard Disability (40% or more but less than 80%) U/S 80U/80DD",
    svd: "Severe Disability (80% or more) U/S 80U/80DD",
    "80ds": "Mediclaim U/S 80D (For Self)",
    "80df": "Mediclaim U/S 80D (For Parents)",
    "80dd": "Treatment for Handicapped U/S 80DD",
    "80ddb": "Critical Illness Deduction U/S 80DDB",
    "80e": "Interest on Loan for Higher Education U/S 80E",
    "80g": "Donation Deduction U/S 80G",
    g50: "50% Deduction for Donation U/S 80G",
    g100: "100% Deduction for Donation U/S 80G",
    "80tta": "Savings Account Interest Deduction U/S 80TTA",
    "80ttb": "Interest Deduction for Senior Citizens U/S 80TTB",
    "80u": "Deduction for Self Handicapped Person U/S 80U",
    ccd: "NPS Employee Contribution U/S 80CCD(1)",
    "80b": "Additional NPS Deduction U/S 80CCD(1B)",
    cch: "Central Government Contribution to Agniveer Corpus Fund U/S 80CCH(2)",
  };

  const closeModal = () => setShowModal(false);
  const closeDeducteeModal = () => setShowDeducteeModal(false);
  let clientInfo = JSON.parse(localStorage.getItem("clientInfo"));

  const filtered24QInfo = form24QInfo.filter((info) => {
    const fullName = `${info?.en}`.toLowerCase();
    const term = searchTerm.toLowerCase();
    return info?.en.toLowerCase().includes(term) || fullName.includes(term);
  });

  useEffect(() => {
    const calculatedMaxPage = Math.ceil(filtered24QInfo.length / limit) || 1;
    setMaxPage(calculatedMaxPage);
    if (activePage > calculatedMaxPage) setActivePage(1);
  }, [filtered24QInfo, limit]);

  const initialState = Object.fromEntries(
    form24QFields.map((f) => [f.key, ""]),
  );
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    if (form24QInfo.length > 0 && isDataSentToCA(form24QInfo) === true) {
      setIsDataSendToCA(true);
    } else {
      setIsDataSendToCA(false);
    }
    if (form24QInfo.length > 0 && isDataReviewByCA(form24QInfo) === true) {
      setIsDataReviewedByCA(true);
    } else {
      setIsDataReviewedByCA(false);
    }
  }, [form24QInfo]);

  useEffect(() => {
    setEmpIds([]);
  }, [selectedYear, selectedQuarter, selectedMonth]);

  const deleteEmployee = async (e) => {
    if (isDataSendToCA) return;
    if (empIds?.length === 0) {
      showError("You have not selected any employee to delete");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    if (result.isConfirmed) {
      try {
        const results = await Promise.allSettled(
          empIds.map((empId) => {
            let payload = {
              action: "formdelete",
              ty: "form24q",
              to: clientInfo?.tk,
              id: empId,
            };
            apiPost(process.env.REACT_APP_API_URL, payload);
          }),
        );
        let processed = 0;
        console.log("results", results);
        results.forEach((result, index) => {
          processed++;
          if (result.status === "fulfilled") {
            if (processed === results.length) {
              setTimeout(() => {
                get24QInfo();
                setEmpIds([]);
                showSuccess(`Employee delete successfully!!!`);
              }, 500);
            }
          } else {
            console.error(`Failed to delete ID ${index}`, result.reason);
            showError(`Failed to delete ID ${index}`, result.reason);
            // showError(result?.errordetails?.error);
            return;
          }
        });
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      }
    }
  };

  const getGPS_GISTotal = async (panno) => {
    const payload = {
      action: "showgpfgistotal",
      to: clientInfo?.tk,
      ty: "form24q",
      fi: selectedFYearId,
      mn: selectedMonth,
      pa: panno,
    };

    console.log("payload", payload);

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);

      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setShowLoader(false);
      } else if (response?.responsedetails) {
        console.log("response GPS and GIS Total", response?.responsedetails);
        // getDeducteeDetailInfo(response?.responsedetails);
        if (response?.responsedetails) {
          return response?.responsedetails;
        }
      }
    } catch (err) {
      console.error("Error:", err);
      showError("Something went wrong");
      setShowLoader(false);
    } finally {
      setShowLoader(false);
    }
  };

  const get24QInfo = async () => {
    if (clientInfo?.tk && clientInfo?.tk !== "") {
      if (selectedFYearId <= 0) {
        showError("Please select financial year to proceed");
        return;
      }

      if (selectedQuarter === "") {
        showError("Please select quarter to proceed");
        return;
      }

      if (selectedMonth === "") {
        showError("Please select month to proceed");
        return;
      }

      setShowLoader(true);
      const payload = {
        action: "formlist",
        to: clientInfo?.tk,
        ty: "form24q",
        fi: selectedFYearId,
        mn: selectedMonth,
        //clid: clientInfo.client?.id,
      };

      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);

        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setShowLoader(false);
        } else if (response?.responsedetails) {
          console.log("response", response?.responsedetails);
          setForm24QInfo(response?.responsedetails || []);
          setEmpIds([]);

          // getDeducteeDetailInfo(response?.responsedetails);

          setTimeout(() => {
            setShowLoader(false);
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setShowLoader(false);
      } finally {
        setShowLoader(false);
      }
    }
  };

  const handleAdd = () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }
    setShowModal(true);
    setEditingIndex(null);
    setLoading(false);
    setFormData(initialState);
  };

  const handleEdit = async (selectedInfo) => {
    console.log("selectedInfo", selectedInfo);
    if (isDataSendToCA) return;
    const empAge = moment().diff(
      moment(selectedInfo["ed"], "YYYY-MM-DD"),
      "years",
    );

    const response = await getGPS_GISTotal(selectedInfo["pa"]);

    console.log("response in edit", response[0].totalgis, response[0].totalgpf);

    setFormData({
      "80b": selectedInfo["80b"],
      "80c": selectedInfo["80c"],
      "80d": selectedInfo["80d"],
      "80g": selectedInfo["80g"],
      "80u": selectedInfo["80u"],
      "80ds": selectedInfo["80ds"],
      "80df": selectedInfo["80df"],
      "80dd": selectedInfo["80dd"],
      "80ddb": selectedInfo["80ddb"],
      "80e": selectedInfo["80e"],
      "80tta": selectedInfo["80tta"],
      "80ttb": selectedInfo["80ttb"],
      aa1: selectedInfo["aa1"],
      aa2: selectedInfo["aa2"],
      aa3: selectedInfo["aa3"],
      aa4: selectedInfo["aa4"],
      aa5: selectedInfo["aa5"],
      ad1: selectedInfo["ad1"],
      ad2: selectedInfo["ad2"],
      an1: selectedInfo["an1"],
      an2: selectedInfo["an2"],
      ar: selectedInfo["ar"],
      ba: selectedInfo["ba"],
      bo: selectedInfo["bo"],
      ca: selectedInfo["ca"],
      ccd: selectedInfo["ccd"],
      da: selectedInfo["da"],
      de: selectedInfo["de"],
      en: selectedInfo["en"],
      gis: selectedInfo["gis"],
      gp: selectedInfo["gp"],
      gpf: selectedInfo["gpf"],
      gt: selectedInfo["gt"],
      hp: selectedInfo["hp"],
      hr: selectedInfo["hr"],
      it: selectedInfo["it"],
      lic: selectedInfo["lic"],
      na: selectedInfo["na"],
      nps: selectedInfo["nps"],
      pa: selectedInfo["pa"],
      pi: selectedInfo["pi"],
      ppf: selectedInfo["ppf"],
      td: selectedInfo["td"],
      tf: selectedInfo["tf"],
      ti: selectedInfo["ti"],
      toa: selectedInfo["toa"],
      toi: selectedInfo["toi"],
      id: selectedInfo["id"],
      nt: selectedInfo["nt"],
      // "disability" column stores a single value: "sd" or "se"
      sd: selectedInfo["ds"] === "sd" ? 1 : 0,
      svd: selectedInfo["ds"] === "se" ? 1 : 0,
      // "80gTyp" column stores an int: 50 or 100 (use == to handle number/string from PHP)
      g50: selectedInfo["80gTyp"] == 50 ? 1 : 0,
      g100: selectedInfo["80gTyp"] == 100 ? 1 : 0,
      ed: selectedInfo["ed"],
      eg: selectedInfo["eg"],
      ead: selectedInfo["ead"],
      ec: selectedInfo["ec"],
      es: selectedInfo["es"],
      eco: selectedInfo["eco"],
      adn: selectedInfo["adn"],
      epc: selectedInfo["epc"],
      os: selectedInfo["os"],
      gpfad: selectedInfo["gpfad"],
      hrad: selectedInfo["hrad"],
      vcld: selectedInfo["vcld"],
      va: selectedInfo["va"],
      vn: selectedInfo["vn"],
      ddd: selectedInfo["ddd"],
      empAge: empAge || "0",
      gpfTotal: response[0].totalgpf,
      gisTotal: response[0].totalgis,
      empContTotal: response[0].totalEmpCon,
      rp: selectedInfo["rp"],
      si: selectedInfo["si"],
      fdi: selectedInfo["fdi"],
      fpi: selectedInfo["fpi"],
      "80cch2": selectedInfo["80cch2"],
      emc: selectedInfo["emc"],
      mr: selectedInfo["mr"],
      nsci: selectedInfo["nsci"],
    });
    totalGpfValue = response[0].totalgpf;
    totalGisValue = response[0].totalgis;
    totalEmpContValue = response[0].totalEmpCon;

    const index = form24QInfo.findIndex((el) => el.id === selectedInfo["id"]);
    setEditingIndex(index);
    setLoading(false);
    setShowModal(true);
  };

  const downloadTemplateFile = async () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }
    try {
      setDownloadingEmpLoading(true);
      //Write excel download logic
      const fileName = "Upload_Employees_Template.xlsx";
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Template");

      // Define headers
      worksheet.columns = [
        { header: "Sr.No", key: "Sr.No", width: 10 },
        { header: "Name", key: "Name", width: 30 },
        { header: "Pan", key: "Pan", width: 20 },
      ];

      // Add empty rows (optional)
      for (let i = 0; i < 5; i++) {
        worksheet.addRow({ name: "", age: "", email: "", phone: "" });
      }

      // Style header row
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).alignment = { horizontal: "center" };

      // Generate buffer and save
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
      setDownloadingEmpLoading(false);
      return;
    } catch (err) {
      console.error("Error:", err);
      setDownloadingEmpLoading(false);
      showError("Something went wrong");
    }
  };

  const uploadTemplateFile = async () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    document.getElementById("fileInput").click();
  };

  // const showFileDialog = async () => {
  //   if (selectedFYearId <= 0) {
  //     showError("Please select financial year to proceed");
  //     return;
  //   }

  //   if (selectedQuarter === "") {
  //     showError("Please select quarter to proceed");
  //     return;
  //   }

  //   if (selectedMonth === "") {
  //     showError("Please select month to proceed");
  //     return;
  //   }

  //   const result = await Swal.fire({
  //     title: "Download Sample File!",
  //     text: "Do you want to download a sample file for upload?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Download!",
  //     width: "320px",
  //     customClass: {
  //       popup: "custom-swal-popup",
  //       confirmButton: "btn btn-sm btn-success",
  //       cancelButton: "btn btn-sm btn-secondary",
  //     },
  //   });

  //   if (result.isConfirmed) {
  //     try {
  //       //Write excel download logic
  //       const fileName = "Upload_Employees_Template.xlsx";
  //       const workbook = new ExcelJS.Workbook();
  //       const worksheet = workbook.addWorksheet("Template");

  //       // Define headers
  //       worksheet.columns = [
  //         { header: "Sr.No", key: "Sr.No", width: 10 },
  //         { header: "Name", key: "Name", width: 30 },
  //         { header: "Pan", key: "Pan", width: 20 },
  //       ];

  //       // Add empty rows (optional)
  //       for (let i = 0; i < 5; i++) {
  //         worksheet.addRow({ name: "", age: "", email: "", phone: "" });
  //       }

  //       // Style header row
  //       worksheet.getRow(1).font = { bold: true };
  //       worksheet.getRow(1).alignment = { horizontal: "center" };

  //       // Generate buffer and save
  //       const buffer = await workbook.xlsx.writeBuffer();
  //       const blob = new Blob([buffer], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       saveAs(blob, fileName);

  //       return;
  //     } catch (err) {
  //       console.error("Error:", err);
  //       showError("Something went wrong");
  //     }
  //   }
  //   document.getElementById("fileInput").click();
  // };

  const handleFileUpload = async (event) => {
    let invalidPANList = [];
    let file = event.target.files[0];
    if (!file) return;

    if (!file.name.endsWith(".xlsx")) {
      showError("Only .xlsx files are allowed.");
      return;
    }

    try {
      const buffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(buffer);

      const worksheet = workbook.worksheets[0];
      const firstRow = worksheet.getRow(1).values;

      if (
        firstRow[1] !== "Sr.No" ||
        firstRow[2] !== "Name" ||
        firstRow[3] !== "Pan"
      ) {
        showError(
          "Excel must have three columns as 'Sr.No' and 'Name' and 'Pan' in first row",
        );
        event.target.value = "";
        return;
      }
      setUploadingEmpLoading(true);

      for (let i = 2; i <= worksheet.rowCount; i++) {
        const row = worksheet.getRow(i);
        const name = row.getCell(2).value;
        const pan = row.getCell(3).value;

        if (name && pan) {
          formData["en"] = name
            .replace(
              /\b(Mr|Mrs|Ms|Miss|Shri|Shree|Dr|Prof|Sir|Madam|Mx)\b\.?\s*/gi,
              "",
            )
            .replace(/\b(Jr|Sr|MD|PhD|DDS|Esq|II|III|IV|V)\b\.?\s*/gi, "")
            .trim()
            .replace(/\s{2,}/g, " ");
          formData["pa"] = pan.toUpperCase();

          const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/i;

          // Check PAN format
          if (!pan || !panRegex.test(pan.trim())) {
            invalidPANList.push({ name, pan });
          }

          const payload = {
            action: "formadd",
            to: clientInfo?.tk,
            ty: "form24q",
            fi: selectedFYearId,
            mn: selectedMonth,
            "80b": formData["80b"],
            "80c": formData["80c"],
            "80d": formData["80d"],
            "80g": formData["80g"],
            "80u": formData["80u"],
            aa1: formData["aa1"],
            aa2: formData["aa2"],
            ad1: formData["ad1"],
            ad2: formData["ad2"],
            an1: formData["an1"],
            an2: formData["an2"],
            ar: formData["ar"],
            ba: formData["ba"],
            bo: formData["bo"],
            ca: formData["ca"],
            ccd: formData["ccd"],
            da: formData["da"],
            de: formData["de"],
            en: formData["en"],
            gis: formData["gis"],
            gp: formData["gp"],
            gpf: formData["gpf"],
            gt: grossTotalValue || formData["gt"],
            hp: formData["hp"],
            hr: formData["hr"],
            it: formData["it"],
            lic: formData["lic"],
            na: netAmountValue || formData["na"],
            nps: formData["nps"],
            pa: formData["pa"],
            pi: formData["pi"],
            ppf: formData["ppf"],
            td: totalDeductionValue || formData["td"],
            tf: formData["tf"],
            ti: formData["ti"],
            toa: totalOtherAllowanceValue || formData["toa"],
            toi: totalOtherIncomeValue || formData["toi"],
          };

          try {
            const response = await apiPost(
              process.env.REACT_APP_API_URL,
              payload,
            );
            console.log("res", response);
          } catch (err) {
            console.error("Error:", err);
            console.log("error in payload", name, pan);
          }
        }
      }
      showSuccess("Uploading Done...");
      setUploadingEmpLoading(false);
      event.target.value = "";
      get24QInfo();

      if (invalidPANList.length > 0) {
        const invalidMsg = invalidPANList
          .map((e) => `Name: ${e.name}<br>PAN: ${e.pan}`)
          .join("<br><br>"); // adds one blank line between entries

        await Swal.fire({
          title: "Invalid PAN",
          html: `
              <div style="
                max-height: 200px;
                overflow-y: auto;
                text-align: left;
                font-size: 14px;
                padding-right: 5px;
              ">
                ${invalidMsg}
              </div>
              <br>
              <div>Please fix from the Edit screen.</div>
            `,
          icon: "info",
          confirmButtonText: "OK",
          width: "400px",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "btn btn-sm btn-primary",
          },
        });
      }
    } catch (err) {
      console.error(err);
      setUploadingEmpLoading(false);
      event.target.value = "";
      showError("Failed to read Excel file.");
    }
  };

  const save24QInfo = async (transType) => {
    if (loading) return;
    if (clientInfo?.tk && clientInfo?.tk !== "") {
      if (formData["en"] === "") {
        showError("Please enter employee name to proceed");
        return;
      }

      if (formData["pa"] === "") {
        showError("Please enter employee pan number to proceed");
        return;
      }

      if (formData["pa"].length !== 10) {
        showError("Invalid PAN Number");
        return;
      }

      if (formData["pa"].charAt(3).toUpperCase() !== "P") {
        showError("Invalid PAN Number");
        return;
      }

      if (formData["epc"] && !/^\d{6}$/.test(formData["epc"].toString())) {
        showError("Please enter correct pinCode");
        return;
      }

      if (selectedMonth === "Mar") {
        if (formData["ed"] === "") {
          showError("please select employee DOB");
          return;
        }

        if (formData["eg"] === "") {
          showError("Please select employee gender");
          return;
        }
      }

      setLoading(true);

      const payload = {
        action: transType === "addInfo" ? "formadd" : "formupdate",
        to: clientInfo?.tk,
        ty: "form24q",
        fi: selectedFYearId,
        mn: selectedMonth,
        "80b": formData["80b"],
        "80c": formData["80c"],
        "80d": formData["80d"],
        "80g": formData["80g"],
        "80u": formData["80u"],
        aa1: formData["aa1"],
        aa2: formData["aa2"],
        ad1: formData["ad1"],
        ad2: formData["ad2"],
        an1: formData["an1"],
        an2: formData["an2"],
        ar: formData["ar"],
        ba: formData["ba"],
        bo: formData["bo"],
        ca: formData["ca"],
        ccd: formData["ccd"],
        da: formData["da"],
        de: formData["de"],
        en: formData["en"],
        gis: formData["gis"],
        gp: formData["gp"],
        gpf: formData["gpf"],
        gt: grossTotalValue || formData["gt"],
        hp: formData["hp"],
        hr: formData["hr"],
        it: formData["it"],
        lic: formData["lic"],
        na: netAmountValue || formData["na"],
        nps: formData["nps"],
        pa: formData["pa"],
        pi: formData["pi"],
        ppf: formData["ppf"],
        td: totalDeductionValue || formData["td"],
        tf: formData["tf"],
        ti: formData["ti"],
        toa: totalOtherAllowanceValue || formData["toa"],
        toi: totalOtherIncomeValue || formData["toi"],
        nt: formData["nt"],
        // single "disability" column: "sd" if Standard checked, "se" if Severe checked, "" if neither
        ds: formData["sd"] === 1 ? "sd" : formData["svd"] === 1 ? "se" : "",
        // single "80gTyp" column (int): 50 if 50% checked, 100 if 100% checked, 0 if neither
        "80gTyp": formData["g50"] === 1 ? 50 : formData["g100"] === 1 ? 100 : 0,
        eg: formData["eg"],
        ed: moment(formData["ed"], "DD/MMM/YYYY").format("YYYY-MM-DD"),
        ead: formData["ead"],
        ec: formData["ec"],
        es: formData["es"],
        eco: formData["eco"],
        rp: formData["rp"],
        adn: formData["adn"],
        ad3: formData["ad3"],
        ad4: formData["ad4"],
        ad5: formData["ad5"],
        "80ds": formData["80ds"],
        "80df": formData["80df"],
        "80dd": formData["80dd"],
        "80ddb": formData["80ddb"],
        "80e": formData["80e"],
        "80tta": formData["80tta"],
        "80ttb": formData["80ttb"],
        epc: formData["epc"],
        os: formData["os"],
        gpfad: formData["gpfad"],
        hrad: formData["hrad"],
        vcld: formData["vcld"],
        va: formData["va"],
        vn: formData["vn"],
        ddd: moment(formData["ddd"], "DD/MMM/YYYY").format("YYYY-MM-DD"),
        si: formData["si"],
        fdi: formData["fdi"],
        fpi: formData["fpi"],
        "80cch2": formData["80cch2"],
        emc: formData["emc"],
        mr: formData["mr"],
        nsci: formData["nsci"],
        ...(transType === "updateInfo" && { id: formData["id"] }),
      };

      console.log("payload", payload);

      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);

        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setLoading(false);
        } else if (response?.responsedetails.success === "yes") {
          console.log("response", response?.responsedetails);
          setTimeout(() => {
            setLoading(false);
            if (transType === "updateInfo") {
              showSuccess("Selected employee updated successfully!!!");
            } else {
              showSuccess("Employee created successfully!!!");
            }
            setShowModal(false);
            get24QInfo();
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setShowLoader(false);
      } finally {
        setShowLoader(false);
      }
    }
  };

  const getLastMonthData = async () => {
    if (copyDataloading) return;

    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    if (filtered24QInfo.length > 0) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to copy data from the previous month to the current month.
               This action may create duplicate entries if similar data already exists.
               Please review and confirm that you want to proceed before continuing!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Copy Data!",
        width: "320px",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "btn btn-sm btn-warning",
          cancelButton: "btn btn-sm btn-secondary",
        },
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    setCopyDataLoading(true);

    if (clientInfo?.tk && clientInfo?.tk !== "") {
      const lastFy = await getPreviousMonthAndFY(
        selectedYear,
        selectedMonth,
        formfinancialYear,
      );

      if (lastFy) {
        setLoading(true);
        const payload = {
          action: "copyformdata",
          to: clientInfo?.tk,
          ty: "form24q",
          ffi: lastFy.financialYearId,
          fmo1: lastFy.month,
          fi: selectedFYearId,
          mo1: selectedMonth,
        };
        try {
          const response = await apiPost(
            process.env.REACT_APP_API_URL,
            payload,
          );

          if (Number(response?.errordetails?.errorcode) > 0) {
            showError(response?.errordetails?.error);
            setCopyDataLoading(false);
          } else if (response?.responsedetails.success === "yes") {
            console.log("response123", response?.responsedetails);
            if (response?.responsedetails?.success === "yes") {
              if (response?.responsedetails?.c1 === 0) {
                setTimeout(() => {
                  setCopyDataLoading(false);
                  showSuccess("No last month data found.");
                }, 3000);
              } else {
                setTimeout(() => {
                  setCopyDataLoading(false);
                  showSuccess("Data copied successfully to selected month");
                  get24QInfo();
                }, 3000);
              }
            }
          }
        } catch (err) {
          console.error("Error:", err);
          showError("Something went wrong");
          setCopyDataLoading(false);
        }
      }
    }
  };

  const submitToCA = async () => {
    if (form24QInfo.length <= 0) {
      showError("There is no such information to proceed");
      return;
    }

    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will freeze the information. Please verify information before proceeding",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    if (result.isConfirmed) {
      if (submitToCALoading) return;

      setsubmitToCALoading(true);

      const payload = {
        action: "formsubmit",
        to: clientInfo?.tk,
        ty: "form24q",
        fi: selectedFYearId,
        mn: selectedMonth,
        ae: "no",
      };

      if (clientInfo?.tk && clientInfo?.tk !== "") {
        try {
          const response = await apiPost(
            process.env.REACT_APP_API_URL,
            payload,
          );
          console.log("response", response);
          if (response?.errordetails?.error !== "") {
            showError(response?.errordetails?.error);
            setsubmitToCALoading(false);
          } else if (response?.responsedetails) {
            console.log("response", response?.responsedetails);
            if (response?.responsedetails?.success === "yes") {
              setTimeout(() => {
                setsubmitToCALoading(false);
                showSuccess("Selected month info submit to CA successfully!!!");
                get24QInfo();
              }, 3000);
            }
          }
        } catch (err) {
          console.error("Error:", err);
          showError("Something went wrong");
          setsubmitToCALoading(false);
        }
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > maxPage) return;
    setActivePage(pageNumber);
  };

  const showChallan = () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    if (form24QInfo.length <= 0) {
      showError("Please add employee detail to proceed");
      return;
    }

    const totalIt = form24QInfo.reduce(
      (sum, item) => sum + (parseFloat(item.it) || 0),
      0,
    );
    setChallanAmount(totalIt);
    setShowChallanInfo(true);
  };

  const hideChallan = () => {
    setShowChallanInfo(false);
  };

  const handelPrintEmpReport = () => {
    navigate("/print-emp-report");
  };

  const handelDeductee = () => {
    setDeducteeEmpPan([]);
    setSearchEmployee("");
    setModelType("DeducteeDetails");
    getDeducteeDetailInfo();
  };

  const handelIncomeTaxMemo = () => {
    setDeducteeEmpPan([]);
    setSearchEmployee("");
    setModelType("IncomeTaxMemo");
    getDeducteeDetailInfo();
  };

  const getDeducteeDetailInfo = async (data) => {
    if (clientInfo?.tk && clientInfo?.tk !== "") {
      // if (selectedMonth !== "Mar") return;
      if (selectedFYearId <= 0) {
        showError("Please select financial year to proceed");
        return;
      }

      // setShowLoader(true);
      setLoading(true);
      const payload = {
        action: "formlist",
        to: clientInfo?.tk,
        ty: "form24q",
        fi: selectedFYearId,
      };
      console.log("getDeducteeDetailInfo payload => ", payload);
      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);

        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setLoading(false);
        } else if (response?.responsedetails) {
          console.log(
            "getDeducteeDetailInfo response => ",
            response?.responsedetails,
          );
          setForm24QDeducteeData(response?.responsedetails || []);

          const data = response?.responsedetails;
          const uniqueEmployee = data
            .filter(
              (item, index, self) =>
                index ===
                self.findIndex(
                  (obj) => obj.en === item.en && obj.pa === item.pa,
                ),
            )
            .map(({ en, pa, de }) => ({ en, pa, de }));
          console.log("uniqueEmployee", uniqueEmployee);
          setEmployee(uniqueEmployee);

          setTimeout(() => {
            setLoading(false);
            setShowDeducteeModal(true);
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setLoading(false);
      } finally {
        setTimeout(() => {
          setLoading(false);
          setShowDeducteeModal(true);
        }, 3000);
      }
    }
  };

  useEffect(() => {
    getFilterDeductee();
  }, [deducteeEmpPan]);

  const getFilterDeductee = () => {
    const filtered = form24QDeducteeData.filter((item) =>
      deducteeEmpPan.includes(item.pa),
    );

    setReport24QDeducteeData(filtered);
  };

  const toggleDeducteeEmpPan = (empPan) => {
    setDeducteeEmpPan(
      (prev) =>
        prev.includes(empPan)
          ? prev.filter((pa) => pa !== empPan) // remove
          : [...prev, empPan], // add
    );
  };

  return (
    <Container fluid className="p-md-4 form24q-container">
      <div className="mt-3">
        <AdminScreenHeader
          title="📋 Form 24Q"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          placeholder="Search Employee..."
          showSearch={true}
        />

        {/* Dropdowns */}
        <DateFilters
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          selectedQuarter={selectedQuarter}
          setSelectedQuarter={setSelectedQuarter}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          getFormInfo={get24QInfo}
          setSelectedFYearId={setSelectedFYearId}
          setFormInfo={setForm24QInfo}
          setFormFinancialYear={setFormFinancialYear}
        />

        {form24QInfo.length > 0 &&
          (isDataReviewedByCA ? (
            <div className="data-send-to-ca">
              This information has already been reviewed by the CA.
            </div>
          ) : isDataSendToCA ? (
            <div className="data-send-to-ca">
              This information has been sent to the CA for review.
            </div>
          ) : null)}

        {/* Right side buttons group */}
        <div className="grid-button-container">
          {/* Left Button */}
          <Button
            className="left-btn btn-primary-submit-to-ca"
            onClick={deleteEmployee}
            disabled={empIds?.length <= 0}
            variant="success"
          >
            <FaTrash
              style={{
                marginRight: "0.5rem",
                marginTop: "-0.3rem",
                transform: "scale(1.2)",
                transformOrigin: "center",
                fontSize: "0.7rem",
              }}
            />
            Delete Selected
          </Button>

          {/* Right Side Buttons */}
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {/* Employee Report */}
            <Button
              className="btn-primary-submit-to-ca"
              onClick={handelPrintEmpReport}
              variant="success"
            >
              <BsPrinter
                style={{
                  marginRight: "0.5rem",
                  transform: "scale(1.2)",
                  transformOrigin: "center",
                }}
              />
              Quarterly Report
            </Button>

            {/* March Buttons */}
            {selectedMonth === "Mar" && (
              <>
                <Button
                  className="btn-primary-submit-to-ca text-nowrap"
                  onClick={handelDeductee}
                  variant="success"
                >
                  <BsPrinter
                    style={{
                      marginRight: "0.5rem",
                      transform: "scale(1.1)",
                    }}
                  />
                  {loading && modelType === "DeducteeDetails" ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Deductee Detail
                    </>
                  ) : (
                    "Deductee Detail"
                  )}
                </Button>

                <Button
                  className="btn-primary-submit-to-ca text-nowrap"
                  onClick={handelIncomeTaxMemo}
                  variant="success"
                >
                  <BsPrinter
                    style={{
                      marginRight: "0.5rem",
                      transform: "scale(1.1)",
                    }}
                  />
                  {loading && modelType === "IncomeTaxMemo" ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Income Tax Memo
                    </>
                  ) : (
                    "Income Tax Memo"
                  )}
                </Button>
              </>
            )}
          </div>
        </div>

        <div className="table-container">
          <Form24QTable
            data={filtered24QInfo}
            onEdit={handleEdit}
            // onDelete={deleteEmployee}
            activePage={activePage}
            limit={limit}
            setEmpIds={setEmpIds}
            selectedMonth={selectedMonth}
            isDataSendToCA={isDataSendToCA}
            empIds={empIds}
          />
        </div>

        <Row className="mt-3 mb-2">
          <Col
            xs={12}
            className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2"
          >
            {/* Records per page */}
            <div className="d-flex align-items-center">
              <label
                className="me-2 mb-0"
                style={{ color: "#0d6efd", fontSize: "13px" }}
              >
                Records per page:
              </label>
              <Form.Select
                value={limit}
                onChange={(e) => {
                  const value =
                    e.target.value === "All"
                      ? filtered24QInfo.length
                      : parseInt(e.target.value);
                  setLimit(value);
                  setActivePage(1); // Reset to first page on limit change
                }}
                style={{ width: "100px" }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100000">All</option>
              </Form.Select>
            </div>

            {/* Pagination */}
            <Pagination className="mb-0">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={activePage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(activePage - 1)}
                disabled={activePage === 1}
              />
              <Pagination.Item>{`Page ${activePage} of ${maxPage}`}</Pagination.Item>
              <Pagination.Next
                onClick={() => handlePageChange(activePage + 1)}
                disabled={activePage >= maxPage}
              />
              <Pagination.Last
                onClick={() => handlePageChange(maxPage)}
                disabled={activePage >= maxPage}
              />
            </Pagination>
          </Col>
        </Row>

        <div className="d-flex flex-column flex-md-row justify-content-between mb-2 mt-3 gap-2">
          <div className="align-self-start"></div>
          <div className="d-flex flex-column flex-md-row gap-2">
            <Button
              className="btn-primary-submit-to-ca w-100 w-md-auto text-nowrap"
              onClick={() => downloadTemplateFile()}
              disabled={isDataSendToCA}
              // onClick={() => showFileDialog()}
            >
              {downloadingEmpLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Downloading...
                </>
              ) : (
                <>
                  <FaCloudDownloadAlt
                    style={{ fontSize: "1.2rem", marginRight: ".2rem" }}
                  ></FaCloudDownloadAlt>
                  <>Download Employees</>
                </>
              )}
            </Button>
            <Button
              className="btn-primary-submit-to-ca w-100 w-md-auto text-nowrap"
              onClick={() => uploadTemplateFile()}
              disabled={isDataSendToCA}
              // onClick={() => showFileDialog()}
            >
              {uploadingEmpLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Uploading...
                </>
              ) : (
                <>
                  <FaCloudUploadAlt
                    style={{ fontSize: "1.2rem", marginRight: ".2rem" }}
                  ></FaCloudUploadAlt>
                  <>Upload Employees</>
                  <span title="Excel must have three columns: Sr.No, Name and Pan in the first row">
                    ℹ️
                  </span>
                </>
              )}
            </Button>

            <input
              id="fileInput"
              type="file"
              accept=".xlsx"
              style={{ display: "none" }}
              onChange={handleFileUpload}
            />
            <Button
              className="btn-primary-submit-to-ca w-100 w-md-auto text-nowrap"
              onClick={() => {
                showChallan();
              }}
            >
              <BsPlus style={{ fontSize: "1.5rem" }} />
              Add Challan Info
            </Button>
            <Button
              className="btn-primary-submit-to-ca w-100 w-md-auto text-nowrap"
              onClick={submitToCA}
              disabled={isDataSendToCA}
            >
              {submitToCALoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Submitting Data...
                </>
              ) : (
                <>
                  <BsSend
                    style={{
                      color: "white",
                      fontSize: "1.3rem",
                      paddingRight: "5px",
                    }}
                  />
                  Submit to CA
                </>
              )}
            </Button>
            <Button
              className="w-100 w-md-auto text-nowrap"
              onClick={handleAdd}
              disabled={isDataSendToCA}
            >
              <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
              Add Employee
            </Button>

            <Button
              className="w-100 w-md-auto text-nowrap"
              onClick={getLastMonthData}
              disabled={isDataSendToCA}
            >
              {copyDataloading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Copying Data...
                </>
              ) : (
                <>
                  <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                  Copy Last Month Data
                </>
              )}
            </Button>

            <Button
              className="w-100 w-md-auto text-nowrap"
              onClick={() => navigate("/client-dashboard")}
            >
              <BsX
                style={{ color: "red", fontSize: "1.5rem", fontWeight: 600 }}
              />
              Close
            </Button>
          </div>
        </div>

        {/* Modal Employee Detail*/}
        <Modal show={showModal} onHide={closeModal} size="lg" scrollable>
          <Modal.Header className="custom-header" closeButton>
            <Modal.Title className="text-primary ">
              Employee Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="g-3">
                {form24QFields.map((field, index) => {
                  if (
                    marchOnlyFields.includes(field.key) &&
                    selectedMonth !== "Mar"
                  ) {
                    return null;
                  }

                  const isTotalBasicValue = field.label === "Total";
                  totalBasicValue = [
                    "ba",
                    "gp",
                    "da",
                    "hr",
                    "ca",
                    "os",
                    "bo",
                    "ar",
                  ]
                    .map((key) => parseFloat(formData[key] || 0))
                    .reduce((sum, val) => sum + val, 0);

                  const isTotalOtherIncome =
                    field.label === "Total Other Income";
                  totalOtherIncomeValue = ["ar", "bo", "an1", "an2"]
                    .map((key) => parseFloat(formData[key] || 0))
                    .reduce((sum, val) => sum + val, 0);

                  const isTotalOtherAllowance =
                    field.label === "Total Other Income";

                  totalOtherAllowanceValue = ["aa1", "aa2"]
                    .map((key) => parseFloat(formData[key] || 0))
                    .reduce((sum, val) => sum + val, 0);

                  const isGrossTotal = field.label === "Gross Total";
                  grossTotalValue = [
                    "ba",
                    "da",
                    "hr",
                    "ca",
                    "gp",
                    "ar",
                    "bo",
                    "an1",
                    "an2",
                    "aa1",
                    "aa2",
                    "nps",
                  ]
                    .map((key) => parseFloat(formData[key] || 0))
                    .reduce((sum, val) => sum + val, 0);

                  const isTotalDeduction = field.label === "Total Deduction";
                  totalDeductionValue = [
                    "gpf",
                    "gpfad",
                    "gis",
                    "hrad",
                    "vcld",
                    "it",
                  ]
                    .map((key) => parseFloat(formData[key] || 0))
                    .reduce((sum, val) => sum + val, 0);
                  const isNetAmount = field.label === "Net Amount";
                  netAmountValue = grossTotalValue - totalDeductionValue;

                  const isNetPaySalary = field.label === "Net Pay Salary";
                  netpaySalary = totalBasicValue - totalDeductionValue;

                  const isTotalDeduction80C =
                    field.label === "Total Deduction u/s 80C";
                  totalDeduction80CValue = [
                    "gpfTotal",
                    "gisTotal",
                    "empContTotal",
                    "ppf",
                    "lic",
                    "tf",
                    "hp",
                    "pi",
                    "ti",
                    "nps",
                    "ad1",
                  ]
                    .map((key) => parseFloat(formData[key] || 0))
                    .reduce((sum, val) => sum + val, 0);

                  const isTotalOtherDeduction =
                    field.label === "Total Other Deduction";
                  totalOtherDeductionValue = [
                    "80ds",
                    "80df",
                    "80dd",
                    "80ddb",
                    "80e",
                    "80g",
                    "80tta",
                    "80ttb",
                    "80u",
                    "80b",
                    "ccd",
                    "cch",
                    "80cch2",
                  ]
                    .map((key) => parseFloat(formData[key] || 0))
                    .reduce((sum, val) => sum + val, 0);

                  const nonNumericFields = [
                    "en",
                    "pa",
                    "adn",
                    "de",
                    "ed",
                    "eg",
                    "ead",
                    "ec",
                    "es",
                    "epc",
                    "eco",
                    "nt",
                    "ddd",
                    "sd",
                    "svd",
                    "g50",
                    "g100",
                  ];

                  return (
                    <React.Fragment key={index}>
                      {/* display used for parmanent show/hide */}
                      <Col md={3} style={{ display: field?.display }}>
                        <Form.Group controlId={`field${index}`}>
                          {/* <Form.Label className="textbox-label">
                            {index === 0 || index === 1 ? (
                              <>
                                {field.label}
                                <span style={{ color: "red" }}>*</span>
                              </>
                            ) : (
                              field.label
                            )}
                          </Form.Label> */}

                          <Form.Label className="textbox-label">
                            {tooltipLabels[field.key] ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-${field.key}`}>
                                    {tooltipLabels[field.key]}
                                  </Tooltip>
                                }
                              >
                                <span
                                  style={{
                                    cursor: "pointer",
                                    borderBottom: "1px dotted #666",
                                  }}
                                >
                                  {field.label}
                                  {(index === 0 || index === 1) && (
                                    <span style={{ color: "red" }}>*</span>
                                  )}
                                </span>
                              </OverlayTrigger>
                            ) : (
                              <>
                                {field.label}
                                {(index === 0 || index === 1) && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </>
                            )}
                          </Form.Label>

                          {field.key === "age" ? (
                            <div
                              style={{
                                border: "1px solid #dee2e6",
                                padding: ".375rem .75rem",
                                borderRadius: "0.375rem",
                                height: "37px",
                              }}
                            >
                              {formData.empAge}
                            </div>
                          ) : field.key === "nt" ? (
                            <Form.Check
                              type="checkbox"
                              name={field.key}
                              checked={formData[field.key] === 1}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  [field.key]: e.target.checked ? 1 : 0,
                                }));
                              }}
                              label=""
                            />
                          ) : field.key === "sd" || field.key === "svd" ? (
                            <Form.Check
                              type="checkbox"
                              name={field.key}
                              checked={formData[field.key] === 1}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const otherKey =
                                  field.key === "sd" ? "svd" : "sd";
                                setFormData((prev) => ({
                                  ...prev,
                                  [field.key]: isChecked ? 1 : 0,
                                  // disability column can hold only one value, so
                                  // selecting one disability type unchecks the other
                                  [otherKey]: isChecked ? 0 : prev[otherKey],
                                }));
                              }}
                              label=""
                            />
                          ) : field.key === "g50" || field.key === "g100" ? (
                            <Form.Check
                              type="checkbox"
                              name={field.key}
                              checked={formData[field.key] === 1}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const otherKey =
                                  field.key === "g50" ? "g100" : "g50";
                                setFormData((prev) => ({
                                  ...prev,
                                  [field.key]: isChecked ? 1 : 0,
                                  // 80gTyp column holds only one value, so
                                  // selecting one type unchecks the other
                                  [otherKey]: isChecked ? 0 : prev[otherKey],
                                }));
                              }}
                              label=""
                            />
                          ) : field.key === "ddd" ? (
                            <Form.Control
                              type="date"
                              name="ddd"
                              value={
                                formData.ddd
                                  ? moment(
                                      formData.ddd,
                                      ["DD/MMM/YYYY", "YYYY-MM-DD"], // 👈 FIX
                                      true, // strict parsing
                                    ).isValid()
                                    ? moment(formData.ddd, [
                                        "DD/MMM/YYYY",
                                        "YYYY-MM-DD",
                                      ]).format("YYYY-MM-DD")
                                    : ""
                                  : ""
                              }
                              onChange={(e) => {
                                const selectedDate = e.target.value;

                                const formattedDate = moment(
                                  selectedDate,
                                  "YYYY-MM-DD",
                                ).format("DD/MMM/YYYY");

                                setFormData((prev) => ({
                                  ...prev,
                                  ddd: formattedDate,
                                }));
                              }}
                            />
                          ) : field.key === "ed" ? (
                            // 📅 Date Picker
                            <Form.Control
                              type="date"
                              name="ed"
                              value={
                                formData.ed
                                  ? moment(
                                      formData.ed,
                                      ["DD/MMM/YYYY", "YYYY-MM-DD"], // 👈 FIX
                                      true, // strict parsing
                                    ).isValid()
                                    ? moment(formData.ed, [
                                        "DD/MMM/YYYY",
                                        "YYYY-MM-DD",
                                      ]).format("YYYY-MM-DD")
                                    : ""
                                  : ""
                              }
                              onChange={(e) => {
                                const selectedDate = e.target.value;

                                const formattedDate = moment(
                                  selectedDate,
                                  "YYYY-MM-DD",
                                ).format("DD/MMM/YYYY");

                                // Calculate age from selected DOB
                                const empAge = moment().diff(
                                  moment(selectedDate, "YYYY-MM-DD"),
                                  "years",
                                );

                                setFormData((prev) => ({
                                  ...prev,
                                  ed: formattedDate,
                                  empAge: empAge,
                                }));
                              }}
                            />
                          ) : field.key === "eg" ? (
                            // 🔽 Gender / Category Dropdown
                            <Form.Select
                              name={field.key}
                              value={formData[field.key] || ""}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  [field.key]: e.target.value,
                                }))
                              }
                            >
                              <option value="">Select</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              {/* <option value="Senior Citizen">
                                Senior Citizen
                              </option>
                              <option value="Super Senior Citizen">
                                Super Senior Citizen
                              </option> */}
                            </Form.Select>
                          ) : (
                            // ✏️ Default Text Input

                            <Form.Control
                              type="text"
                              name={field.key}
                              value={
                                isTotalBasicValue
                                  ? totalBasicValue
                                  : isGrossTotal
                                    ? grossTotalValue
                                    : isTotalDeduction
                                      ? totalDeductionValue
                                      : isNetAmount
                                        ? netAmountValue
                                        : isNetPaySalary
                                          ? netpaySalary
                                          : isTotalDeduction80C
                                            ? totalDeduction80CValue
                                            : isTotalOtherDeduction
                                              ? totalOtherDeductionValue
                                              : isTotalOtherIncome
                                                ? totalOtherIncomeValue
                                                : isTotalOtherAllowance
                                                  ? totalOtherAllowanceValue
                                                  : formData[field.key]
                              }
                              onChange={(e) => {
                                let val = e.target.value;

                                if (field.key === "pa") {
                                  val = val.toUpperCase();
                                }

                                if (!nonNumericFields.includes(field.key)) {
                                  val = val.replace(/[^0-9.]/g, "");

                                  // prevent multiple decimals
                                  const parts = val.split(".");
                                  if (parts.length > 2) {
                                    val =
                                      parts[0] + "." + parts.slice(1).join("");
                                  }
                                }

                                if (!isGrossTotal) {
                                  setFormData((prev) => ({
                                    ...prev,
                                    [field.key]: val,
                                  }));
                                }
                              }}
                              readOnly={
                                isGrossTotal ||
                                field.key === "gpfTotal" ||
                                field.key === "gisTotal" ||
                                field.key === "empContTotal" ||
                                field.key === "age"
                              }
                            />
                          )}
                        </Form.Group>
                      </Col>

                      {/* {selectedMonth === "Mar" &&
                      [
                        "de",
                        "nt",
                        "totalBasic",
                        "gt",
                        "ddd",
                        "an1",

                        "ad5",
                        "totalDeduction",
                      ].includes(field.key) ? (
                        <Col md={12}>
                          <hr />
                        </Col>
                      ) : selectedMonth !== "Mar" &&
                        ["eco", "de", "totalBasic", "ddd"].includes(
                          field.key,
                        ) ? (
                        <Col md={12}>
                          <hr />
                        </Col>
                      ) : null} */}

                      {(() => {
                        let heading = "";

                        if (selectedMonth === "Mar") {
                          switch (field.key) {
                            case "de":
                              heading = " ";
                              break;

                            case "nt":
                              heading = " ";
                              break;

                            case "totalBasic":
                              heading = "DEDUCTIONS";
                              break;

                            case "gt":
                              heading = " ";
                              break;

                            case "ddd":
                              heading = "ADDITIONAL OTHER INCOME";
                              break;

                            case "an1":
                              heading = "ADDITIONAL OTHER ANNUAL DEDUCTIONS ";
                              break;

                            case "ad5":
                              heading = " ";
                              break;

                            case "totalDeduction":
                              heading = "DEDUCTIONS U/S 80CCE";
                              break;

                            default:
                              heading = "";
                          }
                        } else {
                          switch (field.key) {
                            case "eco":
                              heading = " ";
                              break;

                            case "de":
                              heading = " ";
                              break;

                            case "totalBasic":
                              heading = "DEDUCTIONS";
                              break;

                            case "ddd":
                              heading = "";
                              break;

                            default:
                              heading = "";
                          }
                        }

                        return heading ? (
                          <Col md={12} className="my-3">
                            <hr />
                            <div
                              style={{
                                textAlign: "center",
                                fontWeight: "600",
                                fontSize: "16px",
                                // color: "#0d6efd",
                                marginBottom: "8px",
                                backgroundColor: "#e4e274",
                              }}
                            >
                              {heading}
                            </div>
                          </Col>
                        ) : null;
                      })()}
                    </React.Fragment>
                  );
                })}
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-center text-md-end mb-2">
              <Button
                style={{ width: "200px" }}
                className="me-md-3"
                variant="primary"
                onClick={() => {
                  save24QInfo(editingIndex !== null ? "updateInfo" : "addInfo");
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Updating..." : "Adding..."}
                  </>
                ) : (
                  <>
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Update" : "Add"}
                  </>
                )}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        {showChallanInfo ? (
          <ChallanDetail
            show={showChallanInfo}
            onHide={() => {
              hideChallan();
            }}
            formName="form24q"
            selectedFYearId={selectedFYearId}
            selectedMonth={selectedMonth}
            challanAmt={challanAmount}
            selectedYear={selectedYear}
          />
        ) : null}

        {/* Modal Income Tax Memo / Deductee Detail*/}
        <Modal
          show={showDeducteeModal}
          onHide={closeDeducteeModal}
          centered
          size="md"
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-primary ">
              {modelType === "DeducteeDetails"
                ? "Deductee Details"
                : "Income Tax Memo"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Select User */}
            <Row>
              <Col md={12}>
                <Form.Group controlId="financialYear">
                  <Form.Label className="textbox-primary">
                    Financial Year
                  </Form.Label>
                  <Form.Label
                    className="textbox-label ml-5"
                    style={{ paddingLeft: "5px" }}
                  >
                    - {selectedYear}
                  </Form.Label>
                </Form.Group>
              </Col>
            </Row>
            {/* Select Employee */}
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label className="text-primary">
                    Select Employee<span style={{ color: "red" }}>*</span>
                  </Form.Label>

                  {/* Search Box */}
                  <Form.Control
                    type="text"
                    placeholder="Search Employee"
                    value={searchEmployee}
                    onChange={(e) => setSearchEmployee(e.target.value)}
                    className="mb-3 "
                  />

                  {/* Client List */}
                  <div
                    className="border rounded p-2"
                    style={{
                      maxHeight: "250px",
                      overflowY: "auto",
                      fontSize: "0.9rem",
                      backgroundColor: "#2c3e50",
                      color: "#ffffff",
                    }}
                  >
                    {loading ? (
                      <div className="text-center">
                        <Spinner animation="border" size="sm" />
                      </div>
                    ) : (
                      employee
                        .filter((info) =>
                          info.en
                            .toLowerCase()
                            .includes(searchEmployee.toLowerCase()),
                        )
                        .map((info) => (
                          <Form.Check
                            key={info.pa}
                            type="checkbox"
                            label={info.en}
                            checked={deducteeEmpPan.includes(info?.pa)}
                            onChange={() => toggleDeducteeEmpPan(info?.pa)}
                            className="mb-2"
                          />
                        ))
                    )}
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-center text-md-end mb-2">
              <ExportToExcelDeductee24Q
                data={report24QDeducteeData}
                fileName={`${modelType}_${selectedYear}`}
                formName={
                  modelType === "DeducteeDetails"
                    ? "deducteeDetail"
                    : "incometaxMemo"
                }
                clientName={clientInfo.client?.cn}
                clientTan={clientInfo.client?.ta}
                financialYear={selectedYear}
                modelType={modelType}
              />
              <Button
                variant="secondary"
                onClick={() => {
                  setShowDeducteeModal(false);
                }}
                style={{ marginLeft: "10px" }}
              >
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
      {showLoader ? <Loader show={showLoader} /> : null}
    </Container>
  );
};

export default Form24Q;
